<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="info" id="navmanu">
      <b-navbar-brand @click="backtoindex">
        <img src="../static/images/logo.svg" class="d-inline-block align-top" alt="SteemJiang">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <router-link to="/">主页</router-link>
          <router-link to="/category">专栏</router-link>

          <router-link to="/feed">关注</router-link>
          <router-link to="/hot">热门</router-link>
          <router-link to="/search">查询作者</router-link>
          <router-link to="/collection">收藏</router-link>
          <router-link to="/autovote">自动点赞</router-link>
          <router-link to="/comments">评论</router-link>
          <router-link to="/reply">回复</router-link>

          <router-link to="/post">发布</router-link>


          <div v-if="this.$store.state.username">
            <a href="#">@{{this.$store.state.username}}</a>
            <a href="#" @click="logout">注销</a>
          </div>
          <div v-else >

            <a href="https://signup.steemit.com" target="_blank">注册</a>
            <router-link to="/login">登录</router-link>
          </div>


        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view/>

    <!--<Test></Test>-->

    <Footer></Footer>

  </div>
</template>

<script>
  import Footer from './components/Footer'
  import Category from './components/Category'
  import Reply from './components/Reply'
  import Test from './components/Test'
  export default {
    name: 'App',
    data(){
      return {
        username:'',
        password:'',
        keywords: '',

      }
    },
    methods: {
      backtoindex(){
        this.$router.push({path: '/'})
      },

      logout(){
        this.$store.commit('clearUser')
      },

    },

    filters:{
      formatTime(data){
        return data.substring(0,10)
      }
    },

    components: {
      Footer,
      Category,
      Reply,
      Test,
    },

    mounted() {
      if(localStorage.getItem("autostart") !=null){
        console.log(222, '开始点赞啦！')
        let authors = JSON.parse(localStorage.getItem("authors"))
        this.getDataAndVote(authors)
      }

    }
  }
</script>

<style>
  html,body{
    height: 100%;
  }
  #app{
    position:relative;
    width:100%;
    min-height:100%;
    padding-bottom: 7rem;
    box-sizing: border-box;
  }

  .router-link-exact-active{
    color: darkcyan !important;
    border-bottom: 1px solid darkcyan;
    text-align: center;
  }


  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  #navmanu {
    background-color: #da741b !important;

  }
  .align-top{
    margin-left: 3rem;
  }

  #nav-collapse{
    margin-right: 4rem;
  }
  #nav-collapse a{
    color: white;
    margin-right: 0.4rem;
    margin-left: 0.4rem;
  }
  #nav-collapse a:hover{
    color: darkcyan;
    text-decoration: none;
  }
</style>
